import React, {useContext} from 'react'
import './Intro.css'
import Github from '../../img/github.png'
import LinkedIn from '../../img/linkedin.png'
import Hackerank from '../../img/hackerank.png'
import Vector1 from '../../img/Vector1.png'
import Vector2 from '../../img/Vector2.png'
import Boy from '../../img/boy.png'
import ThumbsUp from '../../img/thumbup.png'
import Crown from '../../img/crown.png'
import Glasses from '../../img/glassesimoji.png'
import FloatingDiv from '../floatingDiv/FloatingDiv'
import {themeContext} from '../../Context'
import {motion} from 'framer-motion'



function Intro() {
const transition = {duration: 2, type: 'spring'}
const theme = useContext(themeContext)
const darkMode = theme.state.darkMode
  return (
      <div className="intro">
          <div className="i-left">
              <div className="i-name">
                  <span style={{color: darkMode ? 'white' : ''}}>Hy! I Am</span>
                  <span>Chandra Niketan</span>
                  <span>A certified Full stack developer who having a hunger to learn something New!</span>
              </div>
              <a href="mailto: niketan.kcn@gmail.com">
                <button className='i-button button'>Hire me</button>
              </a>
              <div className="i-icons">
                  <a href="https://github.com/niketan124" target='top'><img src={Github} alt="github" /></a>
                  <a target='top' href="https://www.linkedin.com/in/chandra-niketan-9163ab213?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_contact_details%3BJia8Pq0mR7inxCdDalf%2Beg%3D%3D"><img src={LinkedIn} alt="github" /></a>
                  <a target='top' href="https://www.hackerrank.com/CSE_192P1A0558"><img src={Hackerank} alt="github" /></a>
              </div>
          </div>
          <div className="i-right">
              <img src={Vector1} alt="vector1" />
              <img src={Vector2} alt="vectr2" />
              <img className='myPhoto' src={Boy} alt="my photo" />
              <motion.img
              initial={{left: '-36%'}}
              whileInView={{left: '-24%'}}
              transition={transition} src={Glasses} alt="" />
              <motion.div className='floating-div'
              initial={{top: '-4%', left:'74%'}}
              whileInView={{left: '68%'}}
              transition={transition}
              style={{top: '-4%', left: '58%'}}>
                  <FloatingDiv img={Crown} txt1='Web and Python' txt2='Developer' alt='Web' />
              </motion.div>
              <motion.div className='floating-div1'
              initial={{left: '9rem', top: '18rem'}}
              whileInView={{left: '0rem'}}
              transition={transition}
              style={{top: '18rem', left: '-4rem'}}>
                  <FloatingDiv img={ThumbsUp} txt1='Self Motivated' txt2='Person' alt='thumbsUp' />
              </motion.div>
              {/* blur divs */}
              <div className='i-blur' style={{backgroundColor: 'rgb(238 210 255)'}}>

              </div>
              <div className='i-blur' style={{background: '#C1F5FF', top: '17rem', width: '21rem', height: '11rem', left: '-9rem'}}>

              </div>
          </div>
      </div>
  )
}

export default Intro